import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Search from './Search';
import SearchResults from './SearchResults';
import Details from './Details';
import Edit from './Edit';
import LoggedOut from './LoggedOut';
import Create from './Create';
import MasterDataSearch from './MasterDataSearch'
import { BrowserRouter as Router, Route,Switch} from "react-router-dom";



const routing = (
  <Router>
    <div>
      <Switch>
        <Route path="/details" exact component = {Details} />
        <Route path="/results" exact component = {SearchResults} />
        <Route path="/logout" exact component = {LoggedOut} />
        <Route path="/edit" exact component = {Edit} />
        <Route path="/create" exact component = {Create} />
        <Route path="/MasterDataSearch" exact component = {MasterDataSearch} />
        <Route path="/" exact component={Search} />
      </Switch> 
    </div>
  </Router>
);

ReactDOM.render(routing, document.getElementById('root'))